import SidebarIcons from "../../src/utilities/SidebarIcons";

const sideBarRoutes = {

    setSideBarRoutes: function (sideBarData) {
        let parsedData = sideBarData.data;
        let featureBasedIcons = SidebarIcons(parsedData);
        featureBasedIcons.forEach(el => {
            parsedData.features.find(element => {
                if (element.name === el.name) {
                    element.icon = el.icon;
                    }
                    });
        })
        let sideBarValues = [];

        parsedData.features.forEach(element => {
            let obj = {};
            let childValues = [];
            obj.path = element.path;
            obj.name = element.title;
            obj.icon = element.icon;
            obj.component = element.component;
            obj.layout = "/admin";
            obj.invisible = !element.isEnabled;
            obj.pageTypeId = element.pageTypeId;
            obj.featureId = element.featureId;
            obj.submenu = element.submenu;

            if (element.submenu) {
                element.submenuitem.forEach(childElement => {
                    let childObj = {};

                    childObj.path = childElement.path;
                    childObj.name = childElement.title;
                    childObj.icon = childElement.icon;
                    childObj.component = childElement.component;
                    childObj.layout = "/admin";
                    childObj.invisible = !childElement.isEnabled;
                    childObj.pageTypeId = childElement.pageTypeId;
                    childObj.featureId = childElement.featureId;
                    childObj.customerId = childElement.customerID;
                    childObj.clientToken = childElement.clientToken;
                    childValues.push(childObj);
                });

                obj.submenuitem = childValues;
            }

            sideBarValues.push(obj);
        });

        return sideBarValues;
    }
}

export default sideBarRoutes;